(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/pay/handle-subscription-pay.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/pay/handle-subscription-pay.js');

'use strict';

const {
  utils: {
    generateSubscriptionHref
  }
} = svs.numbergames.prolong_game.common;
const {
  trackSubscriptionPay
} = svs.numbergames.prolong_game.analytics;
const handleSubscriptionPay = (e, _ref) => {
  let {
    wager,
    selectedDays,
    trackingCategory
  } = _ref;
  e.preventDefault();
  const subscriptionHref = generateSubscriptionHref({
    productName: wager.productName,
    wagerId: wager.wagerId,
    selectedDays
  });
  trackSubscriptionPay(subscriptionHref, trackingCategory);
};
setGlobal('svs.numbergames.prolong_game.pay.handleSubscriptionPay', handleSubscriptionPay);

 })(window);